const isIpad = (ua: string): boolean => {
  return ua.includes('ipad') || (ua.includes('macintosh') && 'ontouchend' in document);
};

export const getDeviceType = () => {
  // SAFE: browser UA string, technical/ASCII, never user text
  const ua = navigator.userAgent.toLowerCase();

  if (isIpad(ua)) {
    return 'ipad';
  }

  // Mobile phones
  if (/mobi|iphone|ipod|android.*mobile/.test(ua)) {
    return 'mobile';
  }

  // Tablets (non-iPad)
  if (/android|tablet/.test(ua)) {
    return 'tablet';
  }

  return 'desktop';
};

export const canShareScreen = (): boolean => {
  return getDeviceType() === 'desktop' && !!navigator.mediaDevices?.getDisplayMedia;
};

export const isFirefox = (): boolean => {
  return navigator.userAgent.toLowerCase().includes('firefox');
};

export const isSafari = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('safari') && !/chrome|chromium|crios|fxios|edg|android/.test(ua);
};

export const isIosDevice = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();

  return isIpad(ua) || /iphone|ipod/.test(ua);
};
